import { ITelasInterface } from "../Context/User";

export function mostrarDropdownDeTelas(
    telas: Array<number>,
    telasComAcesso: Array<ITelasInterface>
) {
    return telas.some((tela) =>
        telasComAcesso.some((telaComAcesso) => telaComAcesso.ID_TELA === tela)
    );
}

export function mostrarNavDeTela(
    tela: number,
    telasComAcesso: Array<ITelasInterface>
) {
    return telasComAcesso.some(
        (telaComAcesso) => telaComAcesso.ID_TELA === tela
    );
}
